/* Soothefy custom cart drawer */
(function () {
  'use strict';
  if (customElements.get('sf-cart-drawer')) return;

  class SfCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sfInit) return;
      this.dataset.sfInit = '1';
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      }.bind(this));
    }

    open() {
      this.classList.add('is-open');
      document.body.classList.add('sfcd-lock');
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('sfcd-lock');
    }

    refreshAndOpen() {
      this.open();
      return this.refresh();
    }

    setBusy(on) {
      var inner = this.querySelector('[data-sfcd-inner]');
      if (inner) inner.classList.toggle('is-busy', !!on);
    }

    refresh() {
      var self = this;
      return fetch(window.location.pathname + '?sections=sf-cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['sf-cart-drawer'];
          if (!html) return;
          var tpl = document.createElement('div');
          tpl.innerHTML = html;
          var freshRoot = tpl.querySelector('sf-cart-drawer');
          var freshInner = tpl.querySelector('[data-sfcd-inner]');
          var inner = self.querySelector('[data-sfcd-inner]');
          if (freshInner && inner) inner.replaceWith(freshInner);
          if (freshRoot) {
            var count = freshRoot.getAttribute('data-item-count') || '0';
            self.setAttribute('data-item-count', count);
            document.querySelectorAll('[data-sf-cart-count]').forEach(function (el) {
              el.textContent = count;
              el.setAttribute('data-count', count);
            });
          }
        })
        .catch(function () {})
        .finally(function () { self.setBusy(false); });
    }

    changeLine(line, qty) {
      this.setBusy(true);
      var self = this;
      fetch(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
      }).then(function () {
        return self.refresh();
      }).catch(function () {
        self.setBusy(false);
      });
    }

    addItems(items, btn) {
      this.setBusy(true);
      var self = this;
      var prev = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span>adding\u2026</span>'; }
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return self.refresh();
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = prev; }
        self.setBusy(false);
      });
    }

    onClick(e) {
      var t;
      if (e.target.closest('[data-sfcd-close]')) { this.close(); return; }

      /* Click anywhere outside the panel (the dimmed area) closes the drawer */
      if (!e.target.closest('.sfcd__panel')) { this.close(); return; }

      t = e.target.closest('[data-sfcd-qty]');
      if (t) { this.changeLine(t.dataset.line, t.dataset.qty); return; }

      t = e.target.closest('[data-sfcd-swatch]');
      if (t) {
        var slot = t.closest('[data-sfcd-slot]');
        if (slot) {
          slot.querySelectorAll('[data-sfcd-swatch]').forEach(function (b) {
            b.classList.toggle('is-active', b === t);
          });
        }
        return;
      }

      t = e.target.closest('[data-sfcd-add]');
      if (t) {
        var box = t.closest('[data-sfcd-offer]');
        if (!box) return;
        var ids = [];
        box.querySelectorAll('[data-sfcd-slot]').forEach(function (slot) {
          var sel = slot.querySelector('[data-sfcd-swatch].is-active') || slot.querySelector('[data-sfcd-swatch]');
          if (sel) ids.push(Number(sel.dataset.variant));
        });
        if (!ids.length) return;
        var counts = {};
        ids.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
        var items = Object.keys(counts).map(function (id) {
          return { id: Number(id), quantity: counts[id] };
        });
        this.addItems(items, t);
      }
    }
  }

  customElements.define('sf-cart-drawer', SfCartDrawer);

  /* Header cart link (and anything with data-sf-cart-open) opens the drawer */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sf-cart-open]');
    if (!opener) return;
    var drawer = document.querySelector('sf-cart-drawer');
    if (!drawer) return;
    e.preventDefault();
    drawer.refreshAndOpen();
  });
})();
